import { render, staticRenderFns } from "./channelShopCell.vue?vue&type=template&id=af66a40a&scoped=true"
import script from "./channelShopCell.vue?vue&type=script&lang=js"
export * from "./channelShopCell.vue?vue&type=script&lang=js"
import style0 from "./channelShopCell.vue?vue&type=style&index=0&id=af66a40a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af66a40a",
  null
  
)

export default component.exports